const ruleMap = new Map([
    ["fillColor", "fill"],
    ["strokeColor", "stroke"],
    ["symbol", "mark"],
    ["symbolSize", "mark-size"],
    ["strokeSize", "stroke-width"],
    ["fillOpacity", "fill-opacity"],
    ["dashFinal", "stroke-dasharray"]
])

export default ruleMap